import { jwtDecode } from "jwt-decode";
import isAccess from "./checkAccess";
import { LoginValue } from "../Actions/LoginPageAction";
import { sideBarOpener } from "../Actions/HeaderAction";

export const getDecodedTokenAndAccess = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (!token) return { decodedToken: "", viewGlobalApplication: false };

  const decodedToken = jwtDecode(token);
  const { view: viewGlobalApplication } = isAccess(decodedToken.userRole, "Global Application");

  return { decodedToken, viewGlobalApplication };
};

export const handleDeleteToken = (dispatch) => {
  localStorage.removeItem("token");
  dispatch(LoginValue(false));
  window.location.reload();
};

export const handleSidebarToggle = (dispatch) => {
  dispatch(sideBarOpener(true));
};

export const handleSkipLinkActivate = (event, targetId) => {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.setAttribute("tabindex", "-1");
    targetElement.focus();
    targetElement.addEventListener(
      "blur",
      () => targetElement.removeAttribute("tabindex"),
      { once: true }
    );
  }
};

export const handleSkipLinkKeyDown = (event, targetId) => {
  if (event.key === "Enter" || event.key === " ") {
    handleSkipLinkActivate(event, targetId);
  }
};
